// Copied from the nowadays repo, packages/ui/src/components/input.tsx at 6da58398f. Change it there first, then copy it here, rewriting any em dash (this repo bans them).
"use client"

import * as React from "react"
import {
  composeRenderProps,
  Input as InputPrimitive,
} from "react-aria-components"

import { cn } from "@/nowadays-ui/lib/utils"

// DEVIATION: upstream pairs `disabled:pointer-events-none` with
// `disabled:cursor-not-allowed`. The first cancels the second, an element with
// `pointer-events: none` is never hit-tested, so its cursor rule cannot apply
// and the browser shows the parent's cursor over a disabled field. Dropping
// `pointer-events-none` costs nothing (a disabled input takes no input either
// way) and makes the cursor upstream already asked for actually appear.
// `shadcn add input` reverts this.
//
// DEVIATION: `forwardRef` is ours. Upstream runs on React 19, where `ref` is an
// ordinary prop on a function component. This repo is on React 18, which strips
// `ref` before a plain function sees it, so a caller that focuses the field
// (`inputRef.current?.focus()`) got nothing. Remove the wrapper when this repo
// moves to React 19.
const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentPropsWithoutRef<typeof InputPrimitive>
>(function Input({ className, type, ...props }, ref) {
  return (
    <InputPrimitive
      ref={ref}
      type={type}
      data-slot="input"
      className={composeRenderProps(className, (className) =>
        cn(
          "h-9 w-full min-w-0 rounded-3xl border border-transparent bg-input/50 px-3 py-1 text-base transition-[color,box-shadow,background-color] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
          className
        )
      )}
      {...props}
    />
  )
})

export { Input }
